import {Toggle} from '@/components/atoms'
import {BuyType} from '@/utils/constants/promotionConstants'
import {useState} from 'react'
import {GTINSelection} from './GTINSelection'
import {GTINSTable} from './GTINSTable'

const GTINSContent = ({onSelection, combination, setCombination, isExclude, selectedGtins}) => {
  const [currentSelectedGtin, setCurrentSelectedGtin] = useState('')

  const handleGtinCheckbox = (isChecked, gtin) => {
    onSelection(prev => {
      if (isChecked) {
        return {
          itemType: BuyType.GTINS,
          values: [...prev.values, {id: gtin, displayText: gtin, type: BuyType.GTINS}].filter(
            item => item.type === 'GTIN'
          ),
        }
      } else {
        return {
          itemType: BuyType.GTINS,
          values: prev.values.filter(item => item.id !== gtin),
        }
      }
    })
  }

  return (
    <div>
      <div className="flex min-w-[1200px]">
        <GTINSelection
          selectedGtins={selectedGtins}
          setCurrentSelectedGtin={setCurrentSelectedGtin}
          handleGtinCheckbox={handleGtinCheckbox}
        />
        <GTINSTable key={currentSelectedGtin} currentSelectedGtin={currentSelectedGtin} />
      </div>
      {!isExclude && (
        <div className="absolute bottom-0">
          <Toggle
            isDark
            updateValue={value => {
              setCombination(value)
            }}
            value={combination}
            uiSchema={{size: 'small', label: 'Combination of Products'}}
          />
        </div>
      )}
    </div>
  )
}

export default GTINSContent
